import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Spring/DecimalsA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'DecimalsA',
  field: 'Number',
  weeks: [10, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/1TenthsAsFractions" */ './1TenthsAsFractions'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/2TenthsAsDecimals" */ './2TenthsAsDecimals'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/3TenthsOnAPlaceValueChart" */ './3TenthsOnAPlaceValueChart'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/4TenthsOnANumberLine" */ './4TenthsOnANumberLine'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/5DivideA1DigitNumberBy10" */ './5DivideA1DigitNumberBy10'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/6DivideA2DigitNumberBy10" */ './6DivideA2DigitNumberBy10'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/7HundredthsAsFractions" */ './7HundredthsAsFractions'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/8HundredthsAsDecimals" */ './8HundredthsAsDecimals'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/9HundredthsOnAPlaceValueChart" */ './9HundredthsOnAPlaceValueChart'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/DecimalsA/10DivideA1Or2DigitNumberBy100" */ './10DivideA1Or2DigitNumberBy100'
        )
    })
  ]
});
export default Block;
